exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu-no-padding {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/shared/leada-datepicker/leada-datepicker.component.css
// module id = ../../../../../src/app/shared/leada-datepicker/leada-datepicker.component.css
// module chunks = main